export default {"src":"/_next/static/media/horeca.8b1d6a54.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};